export const iconFontAwesomeFoodBeverageChampagneGlasses = (
	<i className="fa-solid fa-champagne-glasses"></i>
);
